module.exports = __webpack_public_path__ + "img/perzeption-expand.dd7d108f.svg";